<div class="mb-3 card" [style.opacity]="!reviewTarget.enable ? '0.4' : '1'">
  <div class="header-card">
    <img [src]="reviewTarget.logo" class="icon mr-2">
    <input type="text" [(ngModel)]="reviewTarget.name" placeholder="Review Site Name"
      class="form-control" (focus)="onFocus()" (blur)="onBlur()">
    <div *ngIf="focus" class="row absolute">
      <button (click)="editName()" class="mr-2 btn-icon btn-icon-only btn btn-success btn-input">
        <i class="fas btn-icon-sm fa-check-circle"></i>
      </button>
      <button (click)="resetName()" class="mr-2 btn-icon btn-icon-only btn btn-danger btn-input">
        <i class="fas btn-icon-sm fa-times-circle"></i>
      </button>
    </div>
    <div *ngxPermissionsOnly="['enableDisableReviewSitesAtMasterList']" class="btn-actions-pane-right actions-icon-btn">
      <ui-switch [(ngModel)]="reviewTarget.enable" color="#00cc5b" [beforeChange]="OnBeforeChange"></ui-switch>
    </div>
  </div>
  <div class="card-body">
    <div><span class="bold">PREFIX: </span>{{reviewTarget.prefix}}</div>
  </div>
  <div class="d-flex card-footer"
    [style.border-bottom-color]="reviewTarget.enable ? reviewTarget.color : 'transparent'">
    <div class="content-left">
      <i *ngIf="reviewTarget.popular" class="fas btn-icon-lg fa-star"></i>
      <div [style.opacity]="reviewTarget.custom ? '1' : '0'" class="badge">CUSTOM</div>
    </div>
    <div  class="text-right d-flex">
      <div *ngxPermissionsOnly="['editReviewSiteAtMasterList']">
        <button (click)="edit.emit()" class="mr-2 btn-icon btn-icon-only btn btn-outline-primary btn-footer" ngbTooltip="Edit review site">
          <i class="fas btn-icon-m fa-edit"></i>
        </button>
      </div>
      <div *ngxPermissionsOnly="['deleteReviewSitesFromMasterList']">
      <button (click)="deleteClick()" class="mr-2 btn-icon btn-icon-only btn btn-outline-danger btn-footer" ngbTooltip="Delete review site">
       <i class="fas btn-icon-m fa-trash"></i>
      </button>
    </div>
    </div>
  </div>
</div>
